export const USER_BLOCKED = 'USER_BLOCKED';
export const USER_NOT_VERIFIED = 'NOT_VERIFIED';
export const LOGIN_VALUE_KEY_NOT_VERIFIED = 'login-value-not-verified';
